export default __webpack_public_path__ + "static/media/ehab.b90a6c4f.jpg";